<template>
    <div class="pos-relative z-max hidden-not-touch">
        <transition name="fade">
            <div
                v-if="value"
                class="pos-fixed pos-all bg-black fade-3"
                :class="{ 'no-pointer-events': !value }"
                @click="$emit('input', false)"
            />
        </transition>
        <div
            class="brand-book-drawer-icon pos-fixed pos-top pos-left text-white"
            style="width: 3rem"
            @click="$emit('input', true)"
        />
        <div
            class="pos-fixed pos-top h-screen bg-white py"
            style="transition: left 350ms ease-in-out; width: min(80vw, 300px)"
            :style="{ left: value ? 0 : '-100%' }"
        >
            <BrandBookLogoText :animation-duration="animationDuration" />
            <nav>
                <ul class="no-list">
                    <li
                        class="px py-2 uppercase h5"
                        v-for="(title, index) of titles"
                        @click="$emit('click', index) && $emit('input', false)"
                    >
                        <a
                            :class="{
                                'text-primary': index === activeSectionIndex,
                            }"
                            >{{ title }}</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    import LogoCircle from './LogoCircle';
    import BrandBookLogoText from './BrandBookLogoText';

    export default {
        name: 'BrandBookDrawer',
        components: { BrandBookLogoText, LogoCircle },
        props: {
            value: Boolean,
            titles: {
                type: Array,
                required: true,
            },
            activeSectionIndex: {
                type: Number,
                required: true,
            },
            animationDuration: Number,
        },
    };
</script>
